import type { FunctionComponent } from 'react';

import { Button, Tooltip } from '@mantine/core';
import { AddNewDrawers } from 'components/MenuManagement/MenuItemActions/AddNewDrawer/AddNewDrawers';
import { useAddNewDrawers } from 'components/MenuManagement/MenuItemActions/AddNewDrawer/hooks/useAddNewDrawers';
import type { ParentRecord } from 'components/MenuManagement/MenuItemActions/types/newDrawerTypes';

import { PlusCircleIconSm } from '@chownow/pantry/icons';

type AddNewDrawerButtonProps = {
  parentRecord: Partial<ParentRecord>;
};

/* The page-level ADD button. Tree rows add through their actions popover instead (CN-51709). */
export const AddNewDrawerButton: FunctionComponent<AddNewDrawerButtonProps> = ({
  parentRecord,
}) => {
  const { handleAddClick, isDisabled, disabledReason, drawerProps } = useAddNewDrawers({
    parentRecord,
  });

  return (
    <>
      <Tooltip position="top" w="auto" maw="200px" label={disabledReason} disabled={!isDisabled}>
        {/* span wrapper so the tooltip still triggers over the natively-disabled button */}
        <span>
          <Button
            onClick={handleAddClick}
            disabled={isDisabled}
            size="sm"
            variant="ghost"
            leftSection={<PlusCircleIconSm />}
          >
            Add
          </Button>
        </span>
      </Tooltip>
      <AddNewDrawers {...drawerProps} />
    </>
  );
};
